import React from 'react';

import PropTypes from 'prop-types';

import { Dropdown } from '@src/components/ui/Dropdown';
import { HomeArticleResourceTypes } from '@src/utils/homeArticleResourceTypes';


const HomeArticleResourceTypesDropdown = ({ onChange, selectedResourceType, types }) => {
    const handleChange = React.useCallback((value) => {
        if (value === Dropdown.ALL_OPTION) {
            value = null;
        }

        if (onChange) {
            onChange(value);
        }
    }, [onChange]);

    const listTypes = HomeArticleResourceTypes.filter((t) => types.includes(t.id));

    return (
        <Dropdown
            defaultSelection="All Articles"
            title="Filter Articles by"
            list={listTypes}
            selectedOption={selectedResourceType}
            onChange={handleChange}
        />
    );
};

HomeArticleResourceTypesDropdown.propTypes = {
    types: PropTypes.arrayOf(PropTypes.string),
    selectedResourceType: PropTypes.string,
    onChange: PropTypes.func,
};

export default HomeArticleResourceTypesDropdown;
